import { Typography } from '@/components/ui/typography'
import type { Company } from '@/types/api'
import { BoardMemberSection } from './board-member-section'

interface GovernanceSectionProps {
  company: Company
  onUpdate: () => void
}

export function GovernanceSection({
  company,
  onUpdate,
}: GovernanceSectionProps) {
  const { boardSeats, greybullBoardSeats } = company

  return (
    <div className="space-y-3 border-b border-primary/10 pb-3">
      <Typography variant="h6">Governance</Typography>

      <div className="rounded-md border border-primary/20 bg-white/50 p-3 dark:bg-gray-900">
        <Typography variant="body-sm" className="mb-1.5 text-primary/70">
          Greybull Board Seats
        </Typography>
        <Typography as="p" className="text-primary">
          {greybullBoardSeats !== undefined &&
          greybullBoardSeats !== null &&
          boardSeats !== undefined &&
          boardSeats !== null ? (
            <>
              <span className="mr-0.5 rounded bg-primary/8 px-1 py-0.5">
                {greybullBoardSeats}
              </span>
              of {boardSeats}
            </>
          ) : (
            '—'
          )}
        </Typography>
      </div>
      <BoardMemberSection company={company} onUpdate={onUpdate} />
    </div>
  )
}
